import React from 'react'

import {
  TableHeader,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow
} from '../../../../../components/TableComponents'

const SubTableWrongProduct = ({ product }) => {
  return (
    <Table>
      <TableHeader columnInformation={[ { columnName:'Id Lote' } ]} />
      <TableBody>
        {product.lotes_divergencia.map((batch) => {
          return (
            <TableBodyRow key={batch.id_lote}>
              <TableBodyCell>{batch.id_lote}</TableBodyCell>
            </TableBodyRow>
          )
        })}
      </TableBody>
    </Table>
  )
}

export default SubTableWrongProduct
